export type AdminInvoicesQueryType = {
    startDate: string,
    endDate: string,
    bookingNumber: string,
    transactionNumber: string,
    assetTypeGroup: string,
    buyerAccountId: string,
    supplierAccountId: string,
    transactionType: string,
    bookingStatus: string,
    supplierTransactionStatus: string,
    taxStatus: string,
    paymentProcessor: string,
    sortBy: string,
    sortDir: string,
    page: number,
    size: number,
    applyDates?: boolean
};

/** Keys that make the report search all dates while filled (see `withDateRangeBypass`). */
export const ADMIN_INVOICES_DATE_BYPASS_KEYS: readonly (keyof AdminInvoicesQueryType)[] = ['bookingNumber', 'transactionNumber'];
